// src/hooks/useBodyClass.ts
import { useEffect } from 'react';

export function useBodyClass(className: string, active = true) {
    useEffect(() => {
        if (!active || typeof document === 'undefined') return;
        document.body.classList.add(className);
        return () => {
            document.body.classList.remove(className);
        };
    }, [className, active]);
}